import { createSlice } from '@reduxjs/toolkit';
import { IpafResultReducer } from '../../reducers/IpafResultReducer';
import { IIpafResult } from '../../../ipaf/types/IpafResult.types';

const initialState: IIpafResult = {};

export const ipafResultSlice = createSlice({
  name: 'ipafResult',
  initialState,
  reducers: IpafResultReducer,
});

export const { setIpafResult, updateQuoteResults, clearIpafResult } = ipafResultSlice.actions;

export default ipafResultSlice.reducer; 